import authHeader from "./auth-header";
import axios from "axios";
import { API_URL } from "./constants.service";

class HullFranchiseDataService {
  // Get all hull-franchises from the database
  getAll(filter) {
    return axios.post(API_URL + "/hull-franchises", filter, { headers: authHeader() });
  }

  // Create a new hull-franchise
  create(data) {
    return axios.post(API_URL + "/hull-franchise", data, { headers: authHeader() });
  }

  // Get just one hull-franchise
  get(id) {
    return axios.get(API_URL + `/hull-franchise/${id}`, { headers: authHeader() });
  }

  // Delete a specific hull-franchise out of the table.
  delete(id) {
    return axios.delete(API_URL + `/hull-franchise/${id}`, { headers: authHeader() });
  }

  // Update the data of one specific hull-franchise.
  update(id, data) {
    return axios.put(API_URL + `/hull-franchise/${id}`, data, {
      headers: authHeader()
    });
  }

  getAllCurrent() {
    return axios.get(API_URL + "/hull-franchises", { headers: authHeader() });
  }
}

export default new HullFranchiseDataService();